import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { Book, ChartPie, Code, CreditCard, LucideProps, RadioTower, Settings } from 'lucide-react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';

export type FooterMenuIcon = ForwardRefExoticComponent<
  Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>
>;

export const useFooterMenu = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const t = useTranslations('sidebarNav');

  const FooterMenu = useMemo(() => {
    const menuItems: {
      href: string;
      icon: FooterMenuIcon;
      label: string;
      isInternal?: boolean;
      comingSoon?: boolean;
      activeMatch?: string;
      eventName: string;
    }[] = [
      {
        href: `/${clientId}/kb/workspace-info`,
        activeMatch: `/${clientId}/kb`,
        icon: Book,
        label: t('knowledgeBase'),
        eventName: 'nav_menu_knowledge_base',
      },
      {
        href: `/${clientId}/billing`,
        icon: CreditCard,
        label: t('billing'),
        eventName: 'nav_menu_billing',
      },
      {
        href: `/${clientId}/usage`,
        icon: ChartPie,
        label: t('usage'),
        eventName: 'nav_menu_usage',
      },
      {
        href: `/${clientId}/developers`,
        icon: Code,
        label: t('developers'),
        eventName: 'nav_menu_developers',
      },
      {
        href: `/${clientId}/signal-settings/website`,
        activeMatch: `/${clientId}/signal-settings`,
        icon: RadioTower,
        label: t('signalSettings'),
        eventName: 'nav_menu_signal_settings',
      },
      {
        href: `/${clientId}/settings/general`,
        activeMatch: `/${clientId}/settings`,
        icon: Settings,
        label: t('workspaceSettings'),
        eventName: 'nav_menu_workspace_settings',
      },
    ];

    return menuItems;
  }, [clientId, t]);

  return FooterMenu;
};
